import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { map } from 'rxjs';
import { Value } from '../interfaces/models/value.model';

@Injectable({
  providedIn: 'root'
})
export class ValueService {
  constructor(private http: HttpClient) { }
  private domain = environment.domain;
  getListValue(id: number) {
    return this.http.get(this.domain + `strategies/${id}/values`).pipe(map((data: any) => {
      return data["data"]["values"] as Value[];
    }))
  }
  createtValue(model: Partial<Value>, strategyId: number) {
    return this.http.post(this.domain + `strategies/${strategyId}/values`, model);
  }
  updatetValue(model: Partial<Value>, strategyId: number, valueId: number) {
    return this.http.put(this.domain + `strategies/${strategyId}/values/${valueId}`, model);
  }
  deletetValue(strategyId: number, valueId: number) {
    return this.http.delete(this.domain + `strategies/${strategyId}/values/${valueId}`);
  }
}
